import axios from "axios";
import JobsApplied from "../pages/jobseeker/dashboard/JobsApplied";

// const API_BASE = "https://job-auth-y09k.onrender.com/api";
const API_BASE = "https://hourlee.in/api";

const API = axios.create({
  baseURL: API_BASE,
});

// Public APIs
export const getCities = () => API.get("/auth/public-cities");
export const getExperience = () => API.get("/auth/public-experience-range");
export const getJobTitles = async (letter) => {
  return await API.get(`/auth/list/${letter}`);
};
export const getCategories = () => API.get("/auth/public-categories");
export const getActiveJob = () => API.get("/auth/top-categories");

export const getIndustryData = () =>
  API.get("/auth/public-industries?page=1&limit=100");
export const getJobTypeData = () => API.get("/auth/publicJobtypes");

export const getJobList = ({
  page = 1,
  limit = 5,
  city = "",
  jobTitle = "",
  industryType = "",
  jobType = "",
  experience = "",
  minSalary = "",
  maxSalary = "",
} = {}) => {
  let url = `/auth/public-jobs?page=${page}&limit=${limit}`;

  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (jobTitle) url += `&jobTitle=${encodeURIComponent(jobTitle)}`;
  if (industryType) url += `&industryType=${encodeURIComponent(industryType)}`;
  if (jobType) url += `&jobType=${encodeURIComponent(jobType)}`;
  if (experience) url += `&experience=${encodeURIComponent(experience)}`;
  if (minSalary) url += `&minSalary=${encodeURIComponent(minSalary)}`;
  if (maxSalary) url += `&maxSalary=${encodeURIComponent(maxSalary)}`;

  return API.get(url);
};

export const getJobsByCategory = ({
  categoryId,
  page = 1,
  limit = 5,
  city = "",
  jobTitle = "",
  industryType = "",
  jobType = "",
  experience = "",
  minSalary = "",
  maxSalary = "",
} = {}) => {
  if (!categoryId) throw new Error("categoryId is required");
  console.log(industryType);

  let url = `/auth/public-categories/${categoryId}?page=${page}&limit=${limit}`;

  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (jobTitle) url += `&jobTitle=${encodeURIComponent(jobTitle)}`;
  if (industryType) url += `&industryType=${encodeURIComponent(industryType)}`;
  if (jobType) url += `&jobType=${encodeURIComponent(jobType)}`;
  if (experience) url += `&experience=${encodeURIComponent(experience)}`;
  if (minSalary) url += `&minSalary=${encodeURIComponent(minSalary)}`;
  if (maxSalary) url += `&maxSalary=${encodeURIComponent(maxSalary)}`;

  console.log("Fetching jobs by category URL:", url);
  return API.get(url);
};

export const getJobsDetails = ({ jobId } = {}) => {
  let url = `/auth/public-job-details/${jobId}`;
  return API.get(url);
};

export const getFeaturedCompanies = () =>
  API.get("/auth/public-featured-companies");

export const getJobsByCompany = ({
  companyId,
  page = 1,
  limit = 5,
  city = "",
  jobTitle = "",
  industryType = "",
  jobType = "",
  experience = "",
  minSalary = "",
  maxSalary = "",
} = {}) => {
  if (!companyId) throw new Error("companyId is required");

  let url = `/auth/public-companies/${companyId}?page=${page}&limit=${limit}`;

  if (city) url += `&city=${encodeURIComponent(city)}`;
  if (jobTitle) url += `&jobTitle=${encodeURIComponent(jobTitle)}`;
  if (industryType) url += `&industryType=${encodeURIComponent(industryType)}`;
  if (jobType) url += `&jobType=${encodeURIComponent(jobType)}`;
  if (experience) url += `&experience=${encodeURIComponent(experience)}`;
  if (minSalary) url += `&minSalary=${encodeURIComponent(minSalary)}`;
  if (maxSalary) url += `&maxSalary=${encodeURIComponent(maxSalary)}`;

  console.log("Fetching jobs by category URL:", url);
  return API.get(url);
};

// Authenticated API
export const getProfileData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-jobSeeker-profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getJobProfileData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/job-profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// console.log("Token:", localStorage.getItem("token"));
export const getCityData = async () => {
  try {
    const response = await API.get("/auth/public-cities"); // no headers
    return response.data;
  } catch (err) {
    console.error("Error fetching cities:", err.message);
    throw err;
  }
};

export const uploadProfileImage = (imageFile) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const formData = new FormData();
  formData.append("image", imageFile);

  return API.post("/auth/jobSeeker-profile-image", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const uploadJobSeekerProfile = (profileData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  console.log("ppooi:", profileData, token);

  return API.post("/auth/create-jobSeeker-profile", profileData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// Education
export const getEducationData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-education", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadEducation = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  // console.log("ppooi:", profileData);

  return API.post("/auth/create-education", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const deleteEducation = (educationId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.delete("/auth/delete-education", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { educationId }, // pass educationId in request body
  });
};

// Work Experience
export const getExperienceData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-workExp", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadWorkExperience = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.post("/auth/create-workExp", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateWorkExperience = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(data);

  return API.put("/auth/update-workExp", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const deleteWorkExperience = (experienceId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.delete("/auth/delete-workExp", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    data: { experienceId },
  });
};

export const uploadResume = (resume) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const formData = new FormData();
  formData.append("resume", resume);

  return API.post("/auth/upload-resume", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getResumeData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-resume", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Skill
export const getSkillData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-skills", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadSkill = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.post("/auth/add-skills", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const deleteSkill = (skill) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.delete(`/auth/delete-skill/${skill}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};

// Bank
export const getBankData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-bankDetails", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const addBankData = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  // console.log("ppooi:", data);

  return API.post("/auth/create-bankDetails", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const updateBankData = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(data);

  return API.put("/auth/update-bankDetails", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// Dashboard
export const getProgressData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get("/auth/seeker-progress-bar", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getDashboardData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token)

  const response = await API.get("/auth/analytics", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Jobs Applied
export const getAppliedJobData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/getAll-appliedJobs", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

// Manage Task
export const getApprovedApplicationData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/my-approved-applications", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const uploadTask = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  // console.log("ppooi:", data);
    if (data.has("hoursWorked")) {
    console.log("hoursWorked is present:", data.get("hoursWorked"));
  } else {
    console.log("hoursWorked is NOT present in FormData");
  }
  return API.post("/auth/upload-task", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getTaskData = async (applicationId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get(`/auth/my-tasks/${applicationId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const applyJob = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(data);
  return API.post("/auth/apply-job", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const saveJob = (jobId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  // console.log("Saving jobId:", jobId);

  return API.post(
    `/auth/savedJobs/${jobId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
};

export const savedJobList = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/seekerSavedJobs", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getJobseekerProfileData = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  const response = await API.get("/auth/get-jobSeeker-profile", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const paymentHistory = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get(`/auth/paymentHistory`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const uploadNewsLetter = (data) => {

  return API.post("/auth/saveEmail", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const notification = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");
  console.log(token);

  const response = await API.get(`/auth/notifications`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export const saveContactMessage = (data) => {

  return API.post("/auth/contactUs", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const saveTermsData = (data) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("User not authenticated");

  return API.post("/auth/termCondition", data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export default API;
